import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { MdKeyboardArrowDown } from "react-icons/md";

import { toastMessage } from "../../utils/toast";
import { clearSession } from "../../utils/initiate";
import { MdKeyboardArrowUp } from "react-icons/md";
import { onMessageListener } from "../../utils/pushNotification";
import Warning from "../Ui/400";
import * as masterActions from "../../Redux/Actions/masterProcess";
import { GetFlyerNotifications } from "../../Redux/Actions/notification";
import { globalSearch } from "../../Redux/Actions/process";
import { getLocaleValue } from "../../utils";
import FlyerNotification from "./flyerNotification";
import "./index.css";

const Home = ({ history }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [departmentsList, setDepartmentsList] = useState([]);
  const [departmentName, setDepartmentName] = useState("");
  const [departmentId, setDepartmentID] = useState("");
  const [openCardID, setOpenCardID] = useState("");
  const [height, setHeight] = useState("");
  const [errStatus, setErrStatus] = useState(200);
  const userData = useSelector(({ User }) => User.data);
  const [keyWord, setKeyWord] = useState("");
  const [searchDetails, setSearchDetails] = useState([]);
  const [data, setData] = useState([]);
  const [enableIframe, setEnableIframe] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [flyerNotificationData, setFlyerNotificationData] = useState(null);
  const [iFrameUrl, setIFrameUrl] = useState("");
  const [formLang, setFormLang] = useState("en");
  const [checkout, setCheckout] = useState("");
  const [multiLangUrl, setMultiLangUrl] = useState("");

  var language = localStorage.getItem("i18nextLng");

  var checkoutJobId = localStorage.getItem("newNotification");
  // var JobID ='';
  if (checkoutJobId != null) {
    setCheckout(checkoutJobId);
  }

  useEffect(() => {
    handleList();
    language === "arabic" ? setFormLang("ar") : setFormLang("en");
  }, [language]);

  useEffect(() => {
    handleCreateFormBuilderURL(multiLangUrl);
  }, [formLang]);

  useEffect(() => {
    if (keyWord.length >= 3) {
      setSearchLoading(true);
      globalSearch(keyWord)
        .then((res) => {
          if (res?.data) {
            var details = res.data?.department?.flatMap(
              ({
                id: departMentId,
                icon,
                localizationKeys: departMentLoc,
                masterProcess,
              }) => {
                return masterProcess?.flatMap(
                  ({
                    id: masterProcessId,
                    localizationKeys: masterProcessLoc,
                    process,
                  }) => {
                    return process?.flatMap(
                      ({
                        id: processId,
                        formId,
                        link,
                        localizationKeys: processLoc,
                      }) => {
                        return {
                          departMentId,
                          departmentName: departMentLoc?.name,
                          departmentDescription: departMentLoc?.description,
                          masterProcessId,
                          masterProcessName: masterProcessLoc?.name,
                          masterProcessDescription:
                            masterProcessLoc?.description,
                          processId,
                          processName: processLoc?.name,
                          link,
                          icon,
                          formId,
                        };
                      }
                    );
                  }
                );
              }
            );
            setSearchDetails(details);
            setSearchLoading(false);
            //  setSearchDetails(res.data?.department);
          }
        })
        .catch((err) => {
          if (err?.response?.status == 401) {
            toastMessage("error", "Access Denied");
            clearSession(dispatch, history);
          } else {
            toastMessage("error", "Error Occured");
          }
          setSearchLoading(false);
        });
    }
  }, [keyWord]);

  useEffect(() => {
    masterActions
      .getProcess()
      .then((res) => {
        if (res && res.data) {
          let departmentsList = res.data.department;
          departmentsList = departmentsList.map(
            ({ localizationKeys, id, masterProcess, icon }) => ({
              label: getLocaleValue(localizationKeys.name),
              localizationKey: localizationKeys.name,
              value: id,
              masterProcess: masterProcess,
              icon: icon,
            })
          );
          setDepartmentsList(departmentsList);
        } else {
          toastMessage("error", "Unable to load the process");
        }
      })
      .catch((err) => {
        setErrStatus(err?.response?.status);
        (err?.response?.status === 401) &&
          clearSession(dispatch, history);
      });
  }, [localStorage.getItem("i18nextLng")]);

  const handleList = (key, ID) => {
    let list = [];
    if (key === "department") {
      list = departmentsList.filter(({ value }) => value === ID)[0]
        .masterProcess;
      list = list.map(({ localizationKeys, id, process }) => ({
        label: localizationKeys.name,
        value: id,
        process: process,
      }));
      setData(list);
    }
  };

  const handleCreateFormBuilderURL = (formURL) => {
    setMultiLangUrl(formURL);
    setIFrameUrl(
      `${formURL}&userID=${userData.UserId}&token=${window.localStorage.jwt}&lang=${formLang}`
    );
  };

  // navigator.serviceWorker.addEventListener('message', event => {
  //   if (event.data.type === 'navigate') {
  //     window.location.href = event.data.url;
  //   }
  // });
   
  

  const openForm = () => {
    setDepartmentID(true);
    setEnableIframe(true);
    // console.log(flyerNotificationData);
    setFlyerNotificationData(null);
    setHeight("1000px");
    handleCreateFormBuilderURL(flyerNotificationData?.deepLinkUrl);
  };

  useEffect(() => {
    if (flyerNotificationData == null) {
      let payload = {
        userId: userData?.UserId,
        statusType: "UnRead",
      };

      GetFlyerNotifications(payload)
        .then((res) => {
          if (res?.data && res.data?.length) {
            let flyerDetails = {
              url: res.data[0]?.documentUrlForWeb,
              id: res.data[0]?.id,
              isDeepLink: res.data[0]?.isDeepLink,
              deepLinkUrl: res.data[0]?.deepLinkUrl,
            };
            if (!enableIframe) {
              setFlyerNotificationData(flyerDetails);
            }
          }
        })
        .catch((err) => {
          err?.response?.status === 401 && clearSession(dispatch, history);
        });
    }
  }, [flyerNotificationData]);

  onMessageListener()
    .then((payload) => {
      let type = payload.data.type;
      let jobId = payload.data.jobID == "0" ? null : payload.data.jobID;

      if (type == "REQUEST_SUBMIT") {
        window.location.reload();
      } else if (type == "AWAITING_PAYMENT") {
        history.push(`/checkout/${jobId}`);
      }
    })
    .catch((err) => {
      setErrStatus(err?.response?.status);
      (err?.response?.status === 401) &&
        clearSession(dispatch, history);
    });

  if (errStatus === 401) {
    return <Warning history={history} />;
  }

  function getProperWords(word) {
    const splitted = word.split(" ");
    let newSplitted = [];
    splitted.forEach((element) => {
      if (element.length > 12) element = element.substr(0, 10) + "...";
      newSplitted.push(element);
    });
    let newWord = newSplitted.join(" ");
    return newWord;
  }

  return (
    <div>
      {flyerNotificationData && (
        <FlyerNotification
          history={history}
          openForm={openForm}
          closeFlyerNotification={setFlyerNotificationData}
          data={flyerNotificationData}
        />
      )}
      <div style={{ textAlign: "center" }}>
        <span
          style={{
            fontSize: "30px",
            borderBottom: "5px solid #b71c1c",
            display: "inline-block",
            marginBottom: "2%",
          }}
        >
          {getLocaleValue("our_services")}
        </span>
      </div>
      <div className="col-md-12 d-flex mt-1">
        {!enableIframe && (
          //   <div className="d-flex " style={{
          //     justifyContent: "center",
          // }}>
          <div
            className="col-md-7 d-flex flex-wrap"
            style={{
              overflowY: "scroll",
              scrollbarWidth: "",
              justifyContent: "flex-start",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "30px",
                width: "100%",
                marginRight: "10px",
                marginBottom: "10px",
              }}
            >
              <input
                className="form-control"
                name="keyWord"
                placeholder={getLocaleValue("search_default_helper_text")}
                value={keyWord}
                onChange={(e) => {
                  setKeyWord(e.target.value);
                }}
              ></input>
              <img
                src="/Assets/search.svg"
                height={"16px"}
                width={"16px"}
                style={{ position: "absolute", right: "20px", top: "10px" }}
              />
            </div>
            {/* <div style={{position: "absolute", top: "50px", width: "100%"}}> */}
            <div
              style={{
                width: "100%",
                zIndex: "1000",
                marginRight: "10px",
                position: "absolute",
                top: 50,
                paddingRight: "10px",
              }}
            >
              {searchLoading ? (
                <Loader
                  type="ThreeDots"
                  color="#ad1a5f"
                  height={40}
                  width={40}
                  style={{ textAlign: "center", marginBottom: "50px" }}
                />
              ) : searchDetails.length == 0 ? (
                keyWord.length > 2 &&
                searchDetails.length == 0 && (
                  <div
                    className="card"
                    style={{ padding: "20px", marginRight: "10px" }}
                  >
                    <div style={{ justifyContent: "center", display: "flex" }}>
                      {getLocaleValue("search_no_result_text")}
                    </div>
                  </div>
                )
              ) : (
                keyWord.length > 2 &&
                searchDetails.map(
                  ({
                    departmentName,
                    departMentId,
                    icon,
                    masterProcessName,
                    processName,
                    link,
                  }) => {
                    return (
                      <div
                        className="card"
                        style={{
                          width: "100%",
                          padding: "5px",
                          cursor: "pointer",
                        }}
                      >
                        <div className="d-flex" style={{ width: "100%" }}>
                          <div className="d-flex">
                            <img
                              src={icon}
                              height={"50px"}
                              width={"50px"}
                              style={{
                                marginTop: "30%",
                                marginLeft: "15px",
                                marginRight: "15px",
                              }}
                            />
                          </div>
                          <div
                            style={{ marginLeft: "10px", width: "100%" }}
                            onClick={() => {
                              handleCreateFormBuilderURL(link);
                              setHeight("1000px");
                              setDepartmentID(departMentId);
                              setEnableIframe(true);
                            }}
                          >
                            {" "}
                            <div>{getLocaleValue(departmentName)}</div>{" "}
                            <div>{getLocaleValue(masterProcessName)}</div>
                            <hr
                              className="hr-dashed"
                              style={{ width: "100%" }}
                            />
                            <div>{getLocaleValue(processName)}</div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )
              )}
            </div>
            {/* </div> */}
            {keyWord.length <= 2 &&
              departmentsList?.map(
                ({ label, localizationKey, icon, value }, index) => (
                  <div
                    key={index}
                    className="document font-weight-bold mb-2 me-2 col-md-2"
                    style={{
                      backgroundColor: "#2d207d",
                      cursor: "pointer",
                      width: "142px",
                      borderRadius: "25px",
                      height: "160px",
                    }}
                    onClick={() => {
                      setDepartmentName(localizationKey);
                      setDepartmentID(value);
                      setEnableIframe(false);
                      setOpenCardID("");
                      handleList("department", value);
                    }}
                  >
                    <div>
                      <div
                        style={{
                          width: "75px",
                          height: "75px",
                          margin: "0 auto",
                        }}
                      >
                        {
                          <img
                            src={icon}
                            style={{
                              backgroundColor: "#2d207d",
                              marginTop: "10px",
                            }}
                            alt="Thumbnail"
                            width="100%"
                            height="100%"
                          />
                        }
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          margin: "0 auto",
                          marginTop: "15px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            color: "white",
                            fontSize: "18px",
                            // fontWeight: "bold",
                            paddingLeft: "2%",
                            paddingRight: "2%",
                          }}
                        >
                          {getProperWords(label)}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              )}
          </div>
          // </div>
        )}
        <div className={enableIframe ? "col-md-12" : "col-md-5"}>
          {!departmentId && (
            <div className="card" style={{ margin: "0 auto", height: "35vw" }}>
              <div
                className="card card-body border-0"
                style={{ marginRight: "50px" }}
              >
                <span
                  className="departmentselect"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "50%",
                  }}
                >
                  {t("extra.AnyDepartment")}
                </span>
              </div>
            </div>
          )}

          {enableIframe && departmentId && (
            <div
              className="card"
              style={{ margin: "0 40px", marginBottom: "16px" }}
            >
              <iframe
                id="fr"
                name="FormData"
                width="100%"
                height={height}
                src={iFrameUrl}
                allow=""
              ></iframe>
            </div>
          )}

          {departmentId && !enableIframe && (
            <div
              className="mb-6"
              style={{
                border: "1px solid #121180",
                borderRadius: 4,
                overflowY: "scroll",
                height: "35vw",
                scrollbarWidth: "none",
              }}
            >
              <div className="d-flex">
                <span
                  className="font-20"
                  style={{
                    margin: "10px auto",
                    borderBottom: "2px solid #b71c1c",
                  }}
                >
                  {getLocaleValue(departmentName)}
                </span>
              </div>

              {
                <div className="accordion accordion-light accordion-toggle-arrow border-0">
                  {data.length ? (
                    data.map(({ label, process }, index) => (
                      <div
                        className="card px-6 border-1"
                        style={{ margin: "20px" }}
                        key={index}
                      >
                        <div
                          className="card1-header border-0"
                          style={{ paddingBottom: "10px", paddingTop: "10px" }}
                          id="headingOne2"
                        >
                          <div
                            className={
                              "d-flex justify-content-between card-title " +
                              (openCardID === index ? "" : "collapsed ") +
                              "flex-row"
                            }
                            onClick={() =>
                              setOpenCardID(openCardID === index ? "" : index)
                            }
                          >
                            <span
                              style={{
                                fontSize: 13,
                                color: "#121180",
                                webkitUserSelect: "none",
                                webkitTouchCallout: "none",
                                mozUserSelect: "none",
                                msUserSelect: "none",
                                userSelect: "none",
                                border: "none",
                                outlineStyle: "none",
                                cursor: "pointer",
                                scrollbarWidth: "none",
                              }}
                            >
                              {getLocaleValue(label)}
                            </span>
                            <div className="d-flex">
                              {openCardID === index ? (
                                <MdKeyboardArrowUp />
                              ) : (
                                <MdKeyboardArrowDown />
                              )}
                            </div>
                          </div>
                        </div>

                        <div
                          className={
                            "collapse cursor-default " +
                            (openCardID === index ? "show" : "")
                          }
                          style={{
                            webkitUserSelect: "none",
                            webkitTouchCallout: "none",
                            mozUserSelect: "none",
                            msUserSelect: "none",
                            userSelect: "none",
                            scrollbarWidth: "none",
                            marginBottom: "10px",
                          }}
                        >
                          {process.length === 0 ? (
                            <span
                              onClick={() => {
                                setOpenCardID("");
                              }}
                              className="processlink"
                              style={{
                                textAlign: "left",
                                fontSize: 13,
                                paddingTop: "0.75rem",
                                marginLeft: "15px",
                              }}
                            >
                              {t("extra.no_data_available")}
                            </span>
                          ) : (
                            process.map(({ localizationKeys, link }, index) => {
                              return (
                                <div
                                  className="listofProcess"
                                  style={{ padding: "0px" }}
                                >
                                  <li key={index} className="processlink">
                                    <span
                                      onClick={() => {
                                        handleCreateFormBuilderURL(link);
                                        setOpenCardID("");
                                        setHeight("1000px");
                                        setEnableIframe(true);
                                      }}
                                      style={{
                                        textAlign: "left",
                                        fontSize: 13,
                                        cursor: "pointer",
                                      }}
                                    >
                                      {getLocaleValue(localizationKeys.name)}
                                    </span>
                                  </li>
                                  <hr className="hr-dashed mt-2 mb-2" />
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      className="px-6"
                      style={{ textAlign: "center", margin: "20px" }}
                    >
                      <span>{t("extra.no_data_available")}</span>
                    </div>
                  )}
                </div>
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
